var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import { create } from '../Style';
import { PullThreshold } from '../constants';
export default create({
  container: function container(style, isRefreshing) {
    return _extends({}, style, {
      height: 0,
      overflow: 'hidden',
      position: 'relative',
      minHeight: isRefreshing ? PullThreshold : 0
    });
  }
});